import { normalizarNombre, type TipoProducto } from "@huayruro/shared";
import type { ResultadoBusqueda } from "./useCatalogoVenta";

// ============================================================
// Forma C del buscador (Kevin, 16-oct-2026): los resultados se agrupan bajo su PRINCIPIO ACTIVO, en el orden en
// que aparece cada uno (lo buscado primero). Dentro de cada grupo: marcas, genéricos, galénicos y aseo; lo que
// tiene stock antes que lo agotado (lo agotado igual se ve, para ofrecer el reemplazo); y si no, el orden del motor.
// Lo que no tiene principio activo (aseo, galénicos sin DCI) va junto al final.
// ============================================================

export type GrupoPrincipio = { clave: string; principio: string | null; items: ResultadoBusqueda[] };

const RANGO_TIPO: Record<TipoProducto, number> = { marca: 0, generico: 1, galenico: 2, aseo: 3 };
const agotado = (r: ResultadoBusqueda) => (r.stock_cache != null && r.stock_cache <= 0 ? 1 : 0);

export function agruparPorPrincipio(resultados: ResultadoBusqueda[]): GrupoPrincipio[] {
  const grupos = new Map<string, GrupoPrincipio>();
  const orden = new Map<ResultadoBusqueda, number>();
  resultados.forEach((r, i) => {
    orden.set(r, i);
    const pa = (r.principio_activo ?? "").trim();
    const clave = pa ? normalizarNombre(pa) : "";
    const g = grupos.get(clave);
    if (g) g.items.push(r);
    else grupos.set(clave, { clave, principio: pa || null, items: [r] });
  });
  const lista = [...grupos.values()];
  for (const g of lista) {
    g.items.sort((a, b) => RANGO_TIPO[a.tipo] - RANGO_TIPO[b.tipo] || agotado(a) - agotado(b) || orden.get(a)! - orden.get(b)!);
  }
  // Sin principio activo, al final (sin cambiar el orden de los demás).
  return [...lista.filter((g) => g.clave !== ""), ...lista.filter((g) => g.clave === "")];
}
